module.exports = {
    title: "快渠通_惠合科技营销管理平台_让营销服务数字智能化",
    description: "惠合科技“快渠通”是面向品牌商销售体系的营销管理平台，为品牌各层级管理者提供覆盖门店、人员、活动到费用的在线管理工具和数字化服务，提升管理效率。",
    keywords: "AI图像识别,门店签约,货补流转,分销管理,惠合科技,快渠通"
}